import { AxiosError, AxiosResponse } from 'axios'
import { camelize } from 'casing'
import {
  startLoading,
  stopLoading,
  LoadingTypes,
  errorLogger,
} from '@labrav/common'
import { getBuyerContactsAPI } from '../../api/marketplace/index'
import type { AppDispatch, RootState } from '../../store/types'

import { BuyerContactsActionTypes, Contacts } from './types'

export { BuyerContactsActionTypes }

export const getBuyerContacts =
  ({ partnerId, buyerId }: { partnerId: string; buyerId: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.BUYERS_OVERVIEW))
    try {
      const response = await getBuyerContactsAPI({ partnerId, buyerId })
      const contacts = camelize(response?.data)
      await dispatch(setBuyerContacts(contacts as Contacts))
    } catch (error: unknown) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState: globalState as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.BUYERS_OVERVIEW))
    }
  }

export const setBuyerContacts = (buyerContacts: Contacts) => ({
  type: BuyerContactsActionTypes.SET_BUYER_CONTACTS,
  payload: buyerContacts,
})
